import { Autocomplete, Popper, TextField } from "@mui/material";
import { GridColDef, GridRowId } from "@mui/x-data-grid";
import { FornecedorDropDown } from "../../../../../../common/domain/models/fornecedor_dropdown";
import { MoneyMaskedInput } from "../../../../../../common/components/masked_inputs/money_masked_input";
import { FuncionarioDropDown } from "../../../../../../common/domain/models/funcionario_dropdown";
import { DefaultDatePickerInput } from "../../../../../../common/components/default_date_picker_input";
import { MoneyMaskedInput2 } from "../../../../../../common/components/masked_inputs/money_masked_input2";

type Props = {
  OnActionValorChange(valor: string | null, idLinhaGrid: GridRowId): void;
  OnActionCentroCustoChange(
    idCentroCusto: number | null,
    idLinhaGrid: GridRowId,
  ): void;
  OnActionCentroCustoDestinoChange(
    idCentroCusto: number | null,
    idLinhaGrid: GridRowId,
  ): void;
  OnActionQuantidadeChange(
    quantidade: number | null,
    idLinhaGrid: GridRowId,
  ): void;
  OnActionLocalAplicacaoChange(
    localAplicacao: string | null,
    idLinhaGrid: GridRowId,
  ): void;
  OnActionFuncionarioChange(
    idFuncionario: number | null,
    idLinhaGrid: GridRowId,
  ): void;
  OnActionDataChange(data: Date | null, idLinhaGrid: GridRowId): void;

  centroCustoLista: any[];
  funcionarioLista: FuncionarioDropDown[];
};

export const GenerateEntradaProdutosMultiColumns = ({
  OnActionValorChange,
  OnActionCentroCustoChange,
  OnActionCentroCustoDestinoChange,
  OnActionQuantidadeChange,
  OnActionFuncionarioChange,
  OnActionDataChange,
  OnActionLocalAplicacaoChange,
  centroCustoLista,
  funcionarioLista,
}: Props): GridColDef[] => {
  return [
    {
      field: "NomeProdutoServico",
      filterable: false,
      headerName: "Produto",
      flex: 1.5,
      minWidth: 200,
      sortable: false,
      renderCell: (params) => {
        return (
          <div className="break-normal w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
            <span>{params.value}</span>
          </div>
        );
      },
    },
    {
      field: "Unidade",
      filterable: false,
      headerName: "Unidade",
      minWidth: 90,
      sortable: false,
      renderCell: (params) => {
        return (
          <div className="break-normal w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
            <span>{params.value}</span>
          </div>
        );
      },
    },
    {
      field: "IdCentroCusto",
      filterable: false,
      flex: 2,
      minWidth: 300,
      headerName: "Centro de Custo",
      sortable: false,
      renderCell: (params) => {
        const { row, id } = params;
        const valorSelecionado = row.IdCentroCusto
          ? centroCustoLista.find((c) => c.id === row.IdCentroCusto) || null
          : null;

        return (
          <div className="w-full flex items-center justify-center h-full p-1">
            <Autocomplete
              size="small"
              fullWidth
              PopperComponent={(props) => (
                <Popper
                  {...props}
                  style={{ width: "auto", minWidth: props.style?.width }}
                  placement="bottom-start"
                />
              )}
              options={centroCustoLista}
              getOptionLabel={(option) => option.title || ""}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              value={valorSelecionado}
              onChange={(_, newValue) => {
                OnActionCentroCustoChange(newValue?.id ?? null, id);
              }}
              renderOption={(props, option) => (
                <li {...props} key={option.id}>
                  {option.title}
                </li>
              )}
              renderInput={(paramsInput) => (
                <TextField
                  {...paramsInput}
                  variant="outlined"
                  placeholder="Selecione..."
                  size="small"
                />
              )}
            />
          </div>
        );
      },
    },
    {
      field: "IdCentroCustoDestino",
      filterable: false,
      flex: 2,
      minWidth: 300,
      headerName: "Centro de Custo Destino",
      sortable: false,
      renderCell: (params) => {
        const { row, id } = params;
        const valorSelecionado = row.IdCentroCustoDestino
          ? centroCustoLista.find((c) => c.id === row.IdCentroCustoDestino) ||
          null
          : null;

        return (
          <div className="w-full flex items-center justify-center h-full p-1">
            <Autocomplete
              size="small"
              fullWidth
              // Removido o disablePortal e adicionado o Popper personalizado para não cortar na tabela
              PopperComponent={(props) => (
                <Popper
                  {...props}
                  style={{ width: "auto", minWidth: props.style?.width }}
                  placement="bottom-start"
                />
              )}
              options={centroCustoLista}
              getOptionLabel={(option) => option.title || ""}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              value={valorSelecionado}
              onChange={(_, newValue) => {
                OnActionCentroCustoDestinoChange(newValue?.id ?? null, id);
              }}
              renderOption={(props, option) => (
                <li {...props} key={option.id}>
                  {option.title}
                </li>
              )}
              renderInput={(paramsInput) => (
                <TextField
                  {...paramsInput}
                  variant="outlined"
                  placeholder="Selecione..."
                  size="small"
                />
              )}
            />
          </div>
        );
      },
    },
    {
      field: "idFuncionario",
      filterable: false,
      flex: 1.5,
      minWidth: 190,
      headerName: "Solicitante",
      sortable: false,
      renderCell: (params) => {
        const { row, id } = params;
        const valorSelecionado = row.IdFuncionario
          ? funcionarioLista.find(
            (f) => f.idFuncionario === row.IdFuncionario,
          ) || null
          : null;

        return (
          <div className="w-full flex items-center justify-center h-full p-1">
            <Autocomplete
              size="small"
              fullWidth
              // Removido o disablePortal e adicionado o Popper personalizado para não cortar na tabela
              PopperComponent={(props) => (
                <Popper
                  {...props}
                  style={{ width: "auto", minWidth: props.style?.width }}
                  placement="bottom-start"
                />
              )}
              options={funcionarioLista}
              getOptionLabel={(option) => String(option.nome) || ""}
              isOptionEqualToValue={(option, value) =>
                option.idFuncionario === value.idFuncionario
              }
              value={valorSelecionado}
              onChange={(_, newValue) => {
                OnActionFuncionarioChange(newValue?.idFuncionario ?? null, id);
              }}
              renderOption={(props, option) => (
                <li {...props} key={option.idFuncionario}>
                  {option.nome}
                </li>
              )}
              renderInput={(paramsInput) => (
                <TextField
                  {...paramsInput}
                  variant="outlined"
                  placeholder="Selecione..."
                  size="small"
                />
              )}
            />
          </div>
        );
      },
    },
    {
      field: "Data",
      filterable: false,
      flex: 1,
      maxWidth: 200,
      headerName: "Data",
      sortable: false,
      renderCell: (params) => {
        const { row, id } = params;
        const data = row.Data ? new Date(row.Data) : null;

        const handleDataChange = (value: Date | null) => {
          OnActionDataChange(value, id);
        };

        return (
          <div className="w-full flex items-center justify-center h-full p-1">
            <DefaultDatePickerInput
              label="Data"
              value={data}
              onChange={handleDataChange}
            />
          </div>
        );
      },
    },
    {
      field: "Quantidade",
      filterable: false,
      flex: 0.8,
      maxWidth: 90,
      headerName: "Quantidade",
      sortable: false,
      renderCell: (params) => {
        const { row, id } = params;
        return (
          <div className="w-full flex items-center justify-center h-full p-1">
            <TextField
              size="small"
              fullWidth
              type="number"
              variant="outlined"
              value={row.Quantidade ?? ""}
              onChange={(e) => {
                const valor = e.target.value ? Number(e.target.value) : null;
                OnActionQuantidadeChange(valor, id);
              }}
            />
          </div>
        );
      },
    },
    {
      field: "ValorUnitario",
      filterable: false,
      flex: 1,
      maxWidth: 180,
      headerAlign: "center",
      headerName: "Valor Unitário",
      sortable: false,
      renderCell: (params) => {
        const { row, id } = params;
        const value =
          row.ValorUnitario !== null && row.ValorUnitario !== undefined
            ? String(row.ValorUnitario)
            : undefined;
        return (
          <div className="break-normal w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
            <MoneyMaskedInput2
              name="ValorUnitario"
              label=""
              readOnly={false}
              value={value}
              onChange={(e) => {
                const novoValor = e;
                OnActionValorChange(novoValor, id);
              }}
            />
          </div>
        );
      },
    },
    {
      field: "LocalAplicacao",
      filterable: false,
      flex: 0.8,
      minWidth: 200,
      headerName: "Local de Aplicação",
      sortable: false,
      renderCell: (params) => {
        const { row, id } = params;
        return (
          <div className="break-normal w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
            <TextField
              size="small"
              fullWidth
              variant="outlined"
              value={row.LocalAplicacao ?? ""}
              onChange={(e) => {
                const valor = e.target.value ? e.target.value : null;
                OnActionLocalAplicacaoChange(valor, id);
              }}
            />
          </div>
        );
      },
    },
  ];
};
